import React from "react";
import { TEMPLATES } from "../../model/accounting/templates/Templates.js";
import { TemplateItem } from "./TemplateItem.js";
import { List } from "../../../packages/ui/list/List.js";

/**
 * Renders the list of available templates.
 */
export const TemplatesList = () => {
  return (
    <List>
      {TEMPLATES.map((template) => (
        <TemplateItem key={template.id} template={template} />
      ))}
    </List>
  );
};
